import { useParams } from "react-router-dom";

import { Form, useFormikContext } from "formik";
import PropTypes from "prop-types";

import { ContentBox } from "components/elements";
import {
  ApplicationField,
  RadioGroupField,
  TextField,
  TiVoTargetsField,
  TiVoApplicationField,
} from "components/form/fields";
import { TARGET_FIELDS } from "components/form/fields/TiVoTargets";
import { Row, Column, Section } from "components/layout";
import { withActiveOrganization } from "containers/Auth/decorators";
import { checkAccess, ROLES } from "containers/Permissions";
import { trans, HtmlTranslation } from "src/translations";

import styles from "./AppManifestTargetTab.scss";
import { META_FIELDS, APP_MODE_RADIO_FIELD } from "./constants";

function TargetTabComponent({ activeOrganization }) {
  const { values, handleChange, setFieldValue } = useFormikContext();
  const { id } = useParams();

  const isReadonly =
    id || !checkAccess({ activeOrganization }, [ROLES.moderator.appIntegrator]);

  const renderAppField = () => {
    const mode = values[META_FIELDS.appMode];
    switch (mode) {
      case "vewd":
        return (
          <ApplicationField name={META_FIELDS.appId} isReadonly={isReadonly} />
        );
      case "tivo":
        return (
          <TiVoApplicationField
            name={META_FIELDS.appId}
            isReadonly={isReadonly}
          />
        );
      default:
        return (
          <TextField
            name={META_FIELDS.appId}
            label={trans.APP_MANIFESTS_TARGET_TAB_APP_ID_LABEL()}
            readOnly={isReadonly}
            disabled={isReadonly}
            dataTestId="application-id"
          />
        );
    }
  };

  return (
    <div className={styles.appId}>
      <Form>
        <Section>
          <Row>
            <Column>
              <Section
                header={trans.APP_MANIFESTS_TARGET_TAB_APP_SECTION_HEADER()}
              >
                {renderAppField()}
                <RadioGroupField
                  {...APP_MODE_RADIO_FIELD}
                  disabled={isReadonly}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue(META_FIELDS.appId, "");
                  }}
                />
              </Section>
              <Section
                header={trans.APP_MANIFESTS_TARGET_TAB_TARGET_SECTION_HEADER()}
              >
                <TiVoTargetsField
                  name={META_FIELDS.targets}
                  fields={Object.values(TARGET_FIELDS)}
                />
              </Section>
            </Column>
            <Column>
              <ContentBox title={trans.APP_MANIFESTS_APPLICATION_GUIDE_TITLE()}>
                <HtmlTranslation
                  component="p"
                  transFunc={trans.APP_MANIFESTS_APPLICATION_GUIDE}
                  className={styles.contentBox}
                />
              </ContentBox>
            </Column>
          </Row>
        </Section>
      </Form>
    </div>
  );
}

TargetTabComponent.propTypes = {
  // from @withActiveOrganization
  activeOrganization: PropTypes.object.isRequired,
};

export const AppManifestTargetTab = withActiveOrganization(TargetTabComponent);
